export const POST_CATEGORIES = [
  'Trends',
  'Look Books',
  '2Dos',
  'Health and Wellness',
  'Travel',
  'Food',
] as const

export type PostCategory = (typeof POST_CATEGORIES)[number]

export type PostType = {
  slug: string
  category: PostCategory
  menu: string
  singular: string
  allLabel: string
  addLabel: string
}

export const POST_TYPES: PostType[] = [
  {
    slug: 'trends',
    category: 'Trends',
    menu: 'Trends',
    singular: 'Trend',
    allLabel: 'All Trends',
    addLabel: 'Add New',
  },
  {
    slug: 'look-books',
    category: 'Look Books',
    menu: 'Look Books',
    singular: 'Look Book',
    allLabel: 'All Look Books',
    addLabel: 'Add New',
  },
  {
    slug: '2dos',
    category: '2Dos',
    menu: '2Dos',
    singular: '2Do',
    allLabel: 'All 2Dos',
    addLabel: 'Add New',
  },
  {
    slug: 'wellness',
    category: 'Health and Wellness',
    menu: 'Wellness',
    singular: 'Wellness post',
    allLabel: 'All Wellness',
    addLabel: 'Add New',
  },
  {
    slug: 'travel',
    category: 'Travel',
    menu: 'Travel',
    singular: 'Travel post',
    allLabel: 'All Travel',
    addLabel: 'Add New',
  },
  {
    slug: 'food',
    category: 'Food',
    menu: 'Food',
    singular: 'Recipe',
    allLabel: 'All Recipes',
    addLabel: 'Add New',
  },
]

export function getPostType(slug: string | undefined) {
  return POST_TYPES.find((type) => type.slug === slug)
}

export function postTypeForCategory(category: string) {
  return POST_TYPES.find((type) => type.category === category) ?? POST_TYPES[0]
}

export const DEFAULT_AUTHOR = 'Sky Haarsma'
export const MAX_UPLOAD_BYTES = 5 * 1024 * 1024
export const POST_STATUSES = ['draft', 'scheduled', 'published'] as const
export type PostStatus = (typeof POST_STATUSES)[number]
export const SOCIAL_TYPES = ['instagram', 'facebook', 'tiktok', 'pinterest', 'twitter'] as const

export function toDatetimeLocal(ms: number) {
  const date = new Date(ms)
  if (Number.isNaN(date.getTime())) return ''
  const pad = (n: number) => String(n).padStart(2, '0')
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`
}

export function defaultScheduleLocal() {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  date.setHours(9, 0, 0, 0)
  return toDatetimeLocal(date.getTime())
}

export const SOCIAL_FIELDS = [
  { type: 'instagram', label: 'Instagram' },
  { type: 'facebook', label: 'Facebook' },
  { type: 'tiktok', label: 'TikTok' },
  { type: 'pinterest', label: 'Pinterest' },
] as const
